import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "Name TextBlue" }
const _hoisted_3 = { class: "Counter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    class: "Discipline",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onDisciplineClick && _ctx.onDisciplineClick(...args))),
    "aria-label": `Search for ${_ctx.disciplineProps?.name}`,
    role: "link"
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("i", { class: "lnr-chevron-right TextBlue" }, null, -1 /* CACHED */)),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.disciplineProps?.name), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.amount), 1 /* TEXT */)
  ], 8 /* PROPS */, _hoisted_1))
}